var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSs8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 102,
    height: 102,
    viewBox: "0 0 102 102",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1002",
    "data-name": "Rectangle 1002",
    width: 102,
    height: 102,
    transform: "translate(1048 4422)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_beauty",
    transform: "translate(-1048 -4422)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "makeup",
    transform: "translate(1054.001 4427.968)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8264",
    "data-name": "Group 8264",
    transform: "translate(52.605 0.032)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8263",
    "data-name": "Group 8263",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6200",
    "data-name": "Path 6200",
    d: "M330.677,5.273a18.638,18.638,0,0,0-25.912,0l-.234.227a18.657,18.657,0,0,0-3.966,21.207l5.872,12.723V82.283a7.871,7.871,0,0,0,7.862,7.862h6.1a7.871,7.871,0,0,0,7.862-7.862V39.449l6.18-12.54A18.581,18.581,0,0,0,330.677,5.273Zm-5.938,77.01a4.347,4.347,0,0,1-4.342,4.342h-6.1a4.347,4.347,0,0,1-4.342-4.342V55.473H317.7V66.817a1.76,1.76,0,0,0,3.52,0V55.473h3.516v26.81Zm-14.784-30.33V40.761h14.784V51.953Zm21.326-26.6-5.858,11.888h-.773l1.418-8.511a1.76,1.76,0,1,0-3.472-.579l-1.515,9.089h-1.974v-8.8a1.76,1.76,0,0,0-3.52,0v8.8h-1.462l-1.515-9.089a1.76,1.76,0,1,0-3.472.579l1.419,8.511H309.3L303.76,25.232a15.133,15.133,0,0,1,3.218-17.2l.234-.227a15.118,15.118,0,0,1,24.07,17.55Z",
    transform: "translate(-298.852 -0.033)",
    fill: "#f9556d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8266",
    "data-name": "Group 8266",
    transform: "translate(0 26.205)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8265",
    "data-name": "Group 8265"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6201",
    "data-name": "Path 6201",
    d: "M23.584,178.887v-7.762a3.524,3.524,0,0,0-2.112-3.224V157.026a5.272,5.272,0,0,0-2.786-4.654l-5.632-3.018a5.28,5.28,0,0,0-7.774,4.654V167.9a3.524,3.524,0,0,0-2.112,3.224v7.762A3.525,3.525,0,0,0,0,182.389v24.992a5.286,5.286,0,0,0,5.28,5.28H21.472a5.286,5.286,0,0,0,5.28-5.28V182.389A3.524,3.524,0,0,0,23.584,178.887ZM8.8,154.008a1.76,1.76,0,0,1,2.591-1.551l5.632,3.018a1.757,1.757,0,0,1,.929,1.551v10.579H8.8ZM6.688,171.125H20.064v7.744H6.688v-7.744Zm16.544,36.256a1.762,1.762,0,0,1-1.76,1.76H18.3V195.766a1.76,1.76,0,1,0-3.52,0v13.376H5.28a1.762,1.762,0,0,1-1.76-1.76V182.389H23.232Z",
    transform: "translate(0 -148.722)",
    fill: "#f9556d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8268",
    "data-name": "Group 8268",
    transform: "translate(14.784 64.8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8267",
    "data-name": "Group 8267"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6202",
    "data-name": "Path 6202",
    d: "M86.993,368.5a1.759,1.759,0,1,0,.516,1.244A1.77,1.77,0,0,0,86.993,368.5Z",
    transform: "translate(-83.989 -367.986)",
    fill: "#f9556d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8270",
    "data-name": "Group 8270",
    transform: "translate(30.272 0.032)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8269",
    "data-name": "Group 8269",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6203",
    "data-name": "Path 6203",
    d: "M193.451,43.328h-8.1V26.08h2.994a1.76,1.76,0,1,0,0-3.52h-2.994V20.448h2.994a1.76,1.76,0,1,0,0-3.52h-2.994V14.816h2.994a1.76,1.76,0,1,0,0-3.52h-2.994V9.184h2.994a1.76,1.76,0,1,0,0-3.52h-2.994V3.552h2.994a1.76,1.76,0,1,0,0-3.52h-9.508a1.76,1.76,0,1,0,0,3.52h2.994V5.664h-2.994a1.76,1.76,0,0,0,0,3.52h2.994V11.3h-2.994a1.76,1.76,0,0,0,0,3.52h2.994v2.112h-2.994a1.76,1.76,0,0,0,0,3.52h2.994V22.56h-2.994a1.76,1.76,0,0,0,0,3.52h2.994V43.328h-8.1a1.76,1.76,0,0,0-1.76,1.76v19.66A47.354,47.354,0,0,0,178.838,89.3a1.76,1.76,0,0,0,1.505.848h6.5a1.76,1.76,0,0,0,1.505-.848,47.355,47.355,0,0,0,6.859-24.548V45.088A1.76,1.76,0,0,0,193.451,43.328Zm-1.76,21.42a43.838,43.838,0,0,1-5.848,21.876h-4.5A43.839,43.839,0,0,1,175.5,64.748V54.592H186.1a1.76,1.76,0,1,0,0-3.52H175.5V46.848h16.192v17.9Z",
    transform: "translate(-171.979 -0.032)",
    fill: "#f9556d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8272",
    "data-name": "Group 8272",
    transform: "translate(71.456 71.215)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8271",
    "data-name": "Group 8271"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6204",
    "data-name": "Path 6204",
    d: "M408.952,404.947a1.759,1.759,0,1,0,.516,1.244A1.773,1.773,0,0,0,408.952,404.947Z",
    transform: "translate(-405.948 -404.431)",
    fill: "#f9556d"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSs8);
export default __webpack_public_path__ + "static/media/ss8.5bbe42dc879d750e0ae3467334e0856f.svg";
export { ForwardRef as ReactComponent };